import { Sun, Moon, Monitor } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@/hooks/useTheme";

/**
 * Single-button theme cycle: light → dark → system.
 * Icon shows the *current* user choice (not the resolved theme).
 */
export default function ThemeToggle() {
  const { t } = useTranslation();
  const { mode, cycle } = useTheme();

  const Icon =
    mode === "light" ? Sun : mode === "dark" ? Moon : Monitor;
  const label =
    mode === "light"
      ? t("theme.title_light")
      : mode === "dark"
      ? t("theme.title_dark")
      : t("theme.title_system");

  return (
    <button
      type="button"
      onClick={cycle}
      title={label}
      aria-label={label}
      className="inline-flex items-center justify-center h-7 w-7 sm:h-8 sm:w-8 rounded-md border border-slate-700 bg-slate-900 text-slate-400 hover:text-slate-200 hover:border-slate-600"
    >
      <Icon className="h-3.5 w-3.5" />
    </button>
  );
}
